import React from "react";
import { Inbox } from "lucide-react";

export function EmptyState({ title = "No records yet", message, action, icon: Icon = Inbox }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[rgba(82,110,126,0.12)] text-[#526E7E]">
        <Icon className="h-6 w-6" />
      </span>
      <div>
        <p className="font-medium text-[#30383C]">{title}</p>
        {message && <p className="mt-1 text-sm text-[rgba(48,56,60,0.6)]">{message}</p>}
      </div>
      {action}
    </div>
  );
}
